
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.333 10a8.333 8.333 0 11-16.666 0 8.333 8.333 0 0116.666 0zM13.09 8.09a.833.833 0 10-1.178-1.18L10 8.823 8.088 6.91a.833.833 0 10-1.178 1.178L8.82 10l-1.91 1.91a.833.833 0 101.178 1.18L10 11.177l1.91 1.911a.833.833 0 001.18-1.178L11.178 10l1.91-1.91z","fill":"#333","opacity":".3"}})])
          )
        }
      }
    